import { FC, useEffect } from 'react'
import { useValidation } from "@pages/makeEvent/hooks/useValidation"
import descriptionSchema from '@pages/makeEvent/steps-components/eventDescription-component/schema.ts'
import { EventDescriptionComponentProps } from '@pages/makeEvent/types'
import s from "@pages/makeEvent/steps-components/eventDescription-component/styles.module.css"

const EventDescriptionComponent: FC<EventDescriptionComponentProps> = ({ formik, setValidDescription }) => {
	const { description } = formik.values
	const isFieldTouched = formik.touched.description
	const { status: validationStatus, errors: validationErrors } = useValidation(descriptionSchema, { description });

  useEffect(() => {
		const valueToApply = validationStatus === 'success' ? description : null
		setValidDescription(valueToApply)
	}, [description])

	return (
		<div className={s.content}>
			<textarea
				className={s.textarea}
				name={"description"}
				value={description}
				onChange={formik.handleChange}
				placeholder={"Описание события"}
				onBlur={formik.handleBlur}
			/>
			{isFieldTouched && validationErrors.description
				? <p className={s.text_error}>{validationErrors.description}</p>
				: null}
			<p className={s.text_info}>
				Используйте слова, которые описывают тематику сообщества и помогают
				быстрее его найти.{" "}
			</p>
		</div>
	)
}

export default EventDescriptionComponent